import ICalibrationUsesLabel = ZoneIQCalibration.ICalibrationUsesLabel;
import ICalibrationUsesType = ZoneIQCalibration.ICalibrationUsesType;
import ICULimportValidationResult = ZoneIQCalibration.ICULimportValidationResult;
import { BaseMutableModel } from '../common-models/base-mutable-model.model';
import * as _ from 'lodash';

export class CalibrationUsesLabelModel extends BaseMutableModel<ICalibrationUsesLabel>
    implements ICalibrationUsesLabel {
    Id: number;
    ZoningCodeId: number;
    CalibrationUsesTypeId: number;
    GridicsUseTagId: number;
    Label: string;
    RevisionId: number;
    CloneId: number;
    ClassId: number;

    importValidationResult?: ICULimportValidationResult;
    calibrationUsesType: ICalibrationUsesType;

    constructor(data: ICalibrationUsesLabel, calibrationUsesType: ICalibrationUsesType, fieldSettings?: any) {
        super(data, ['Id'], fieldSettings, [
            'Id',
            'ZoningCodeId',
            'CalibrationUsesTypeId',
            'GridicsUseTagId',
            'Label',
            'RevisionId',
            'CloneId',
            'ClassId'
        ]);
        this.importValidationResult = data.importValidationResult;
        this.calibrationUsesType = calibrationUsesType;
    }

    get extendedLabel(): string {
        return this.Label
            ? `${this.Label}${
                  _.get(this, 'calibrationUsesType.Name') ? ' (' + this.calibrationUsesType.Name + ')' : ''
              }`
            : this.calibrationUsesType
            ? this.calibrationUsesType.Name
            : '';
    }

    static factory(
        data: ICalibrationUsesLabel,
        calibrationUsesTypes: ICalibrationUsesType[]
    ): CalibrationUsesLabelModel {
        const calibrationUsesType =
            _.isFinite(_.get(data, 'CalibrationUsesTypeId')) && !_.isEmpty(calibrationUsesTypes)
                ? calibrationUsesTypes.find(cut => cut.Id === data.CalibrationUsesTypeId)
                : undefined;
        return new CalibrationUsesLabelModel(data, calibrationUsesType);
    }

    static sortingUsesLabel(a: ICalibrationUsesLabel, b: ICalibrationUsesLabel): number {
        return a.Label < b.Label ? -1 : a.Label > b.Label ? 1 : 0;
    }
}
